import React, { useMemo } from 'react';
import { Box, costFormater } from '@common-fe/common-fe';
import { capitalize } from 'lodash';

import { PlanFundingMethodType, RecordsInfo } from '@/modules/employer/components/Contributions/contributions.types';

import { ContributionInvoiceInfoBox } from './ContributionInvoiceInfoBox';

const INVOICE_NOT_CREATED_VALUE = 'Invoice not created yet';
const WITHOUT_INVOICE_ID_VALUE = 'Record keeping contributions not invoiced';

interface Props {
  record?: RecordsInfo;
  payrollCalendarName?: string;
}

export const ContributionInvoiceListItem: React.FC<Props> = ({
  record,
  payrollCalendarName
}) => {
  // const isHsaRecord = useMemo(() => record?.planCode?.includes('HSA'), [record]);
  const invoiceAmount = useMemo(() => (record?.eeContributionAmount || 0) + (record?.erContributionAmount || 0), [record]);
  const invoiceIdText = useMemo(() => {
    if (record?.fundingMethodType === PlanFundingMethodType.STANDARD_NOTIONAL
      || record?.fundingMethodType === PlanFundingMethodType.PREFUND_SPENDDOWN) {
      return WITHOUT_INVOICE_ID_VALUE;
    }

    if (record?.invoiceId) {
      return record.invoiceId;
    }

    return INVOICE_NOT_CREATED_VALUE;
  }, [record]);

  const hasPayrollCalendar = useMemo(() => !!payrollCalendarName, [payrollCalendarName]);

  return (
    <Box
      data-testid="ContributionInvoiceListItem_container"
      background="canvas"
      direction="row"
      pad={{ vertical: 'spacing8', horizontal: 'spacing16' }}
      round="dropdownItemRound"
      width="100%"
      gap="spacing16"
    >
      <ContributionInvoiceInfoBox
        title="Plan"
        value={record?.planCode || '-'}
        width={hasPayrollCalendar ? '20%' : '25%'}
      />
      <ContributionInvoiceInfoBox
        title="Amount"
        value={costFormater(invoiceAmount, true)}
        width={hasPayrollCalendar ? '18%' : '23%'}
      />
      {hasPayrollCalendar && (
        <ContributionInvoiceInfoBox
          title="Payroll calendar"
          value={payrollCalendarName}
          width='20%'
        />
      )}
      <ContributionInvoiceInfoBox
        title="Invoice ID"
        value={invoiceIdText}
        width={hasPayrollCalendar ? '22%' : '27%'}
      />
      <ContributionInvoiceInfoBox
        title="Status"
        value={capitalize(record?.contributionRequestStatus || record?.invoiceStatusType).replace(/_/g, ' ')}
        isStatus
        width={hasPayrollCalendar ? '20%' : '25%'}
      />
    </Box>
  );
};
